<div class="inner" [class.no-avatar]="!showAvatarPhoto()">
  @if (showAvatarPhoto()) {
  <div class="avatar">
    <qai-avatar
      [size]="'3xlarge'"
      [photoUrl]="avatarPhotoUrl()"
      [fullName]="'John Doe'"
      [fallback]="'placeholder'"
      [speaking]="isAvatarSpeaking()"
    ></qai-avatar>
  </div>
  }

  @if (showSubtitles()) {
  <div class="subtitles">
    <qai-subtitles
      [kind]="subtitleKind()"
      [subtitleText]="subtitleText()"
    ></qai-subtitles>
  </div>
  }

  <div class="controls">
    <ng-content select="app-pathway-call-controls" />
  </div>
</div>
